import { stockIn } from '@/api/stock';

export enum Type {

    ORDER_VIDEO_CALL = 391, // 远程视频
    ORDER_REPORT_DEPT = 392,
    ORDER_CLOSE = 360,
    ORDER_HANDUP = 361,
    ORDER_ROB_DEAL = 371,
    ORDER_WORK_SHEET = 373,
    ORDER_ADD_BRAND = 401,

    ORDER_BBS_LOOK = 433, // 回复留言
    TASK_LOOK = 530,
    TASK_DEAL = 540,
    TASK_SONGXIU = 5500, // 东改 送修
    TASK_REMOTE = 550,
    TASK_VISIT = 551,
    TASK_VISIT_MUST = 5511,
    TASK_VISIT_TIME_MUST = 5512,
    TASK_SEND = 552,
    TASK_TRANSFER = 553,
    TASK_COORDINATION = 554,
    TASK_SET_OUT = 555,
    TASK_APPEAR = 202100,
    ELECTRONIC = 4500000,
    CUSTOMER_ELECTRONIC = 571,

    TASK_PAUSE = 590,
    INQUIRY = 610,

    SERVICE_COMPANY = 750,
    DEPARTMENT = 770,
    FOLLOW_ORDER = 780,
    BRANCH_ORDER = 790,
    BRANCH_ORDER_REPORT = 791,
    BRANCH_ORDER_SERVER = 792,
    PRODUCT_SCAN = 810,
    CHECKPOINT = 850,
    COMPANY_SETTING = 910,
    ROLE_USER = 820,
    VISITOR = 830,
    PUNCH_THE_CLOCK = 840,
    HOME_REPAIR = 912,
    // HOME_SERVICE = 913,
    // HOME_ENGINNER = 914,
    HOME_MAP = 915,
    // 我的订单 报修 ishave权限
    photo = 960000,
    sound = 950000,
    video = 970000,
    tag = 603000,
    pca = 990000,
    dept = 940000,
    CUS_DEPT = 941000,
    product = 301000,
    fault = 750000,
    device = 302000,
    time = 930000,
    price = 500000,
    myselfPCALs = 920000,
    address=891000,
    parts = 350000,
    remark = 980000,

    OtherOpen = 111000, // 东改 订单设置-其他订单-开启

    GZHuth =820000,
    WXAuth = 800000, // 东改 系统设置-基础设置-钉钉设置
    DingDingAuth = 840000, // 东改 系统设置-基础设置-钉钉设置

    //

    // 公司模块
    FAULT_PHENOMENON=615000,
    // 公司模块审核 公司或者部门
    CheckSettingDept=135000,
    //分组审核
    CheckSettingGroup=136000,
    CheckSettingCompany=134000,
    workOrderNum=8600000,
    BJD=730000,
    TASK_CLOSE=153055,
    // 审批
    SP=256000,

    // 联系人 电话 sn模块
    contentUser = 893100,
    contentUserMobile = 893200,
    contentUserPhone = 893300,
    Description = 892000,
    SN = 897100,

    Schedulings=255000,

    DiyOne=895100,
    DiyTwo=895200,

    CustomerHistry=155010, // 客户履历
    DeviceHistry=155000, // 设备履历

    CloseOrder=125100, // 所有订单不是自己的验证权限
    FinishOrder=125400, // 所有订单不是自己的验证权限
    InsteadCheckPass=125600, // 代审

    TaskTrack=270000, // 行程轨迹

    PersonStock=367000, // 员工库管

    TemplateDIY=851000, // 员工库管

    Project=660000, // 项目
    ProjectSeting=661030, // 项目设置
    ProjectCreate=661200, // 项目创建
    ProjectAll=661100, // 项目所有
    ProjectMy=663100, // 项目回收站
    ProjectRecycle=663100, // 项目回收站

    PauseTask=202060, // 暂停任务

    WordFile=894100, // 文档

    Knowledge=480000, // 知识库
    KnowledgeSetting=481000,
    KnowledgeLook=482000,

    // 报修管理
    REPORT_COMPANY_LOOK = 121000,
    REPORT_DEPT_LOOK = 122000,
    REPORT_DEPT_LOOK_SUB = 122100,
    REPORT_FOR_BRANCH_OFFICE = 405000,
    REPORT_ORDER_LOOK = 120000,
    REPORT_CREAT = 102000,
    REPORT_LOOK = 101000,

    MyOrder=1000000,
    OrederCheck=130000, // 审核模块
    MyOrderCheckOrder=132000,
    CheckManigerSetting=133000,

    // 订单管理
    SERVICER_MODULE = 150000, //   维修模块
    ORDER_ADD = 152000,
    ORDER_LOOK = 151000,
    ORDER_LOOK_COM = 151010,
    ORDER_LOOK_DEP = 151020,
    ORDER_ROB_LOOK = 151030,
    ORDER_DEAL = 153000,
    MyAddOrders=151050,
    ServerOrderOutSource=220000,
    ORDER_CHECK = 131000,
    ORDER_ASSIGN_SELF = 153010,
    ORDER_ASSIGN = 153020,
    ORDER_ASSIGN_DEPT = 153021, // 指派部门
    ORDER_ASSIGN_ENGINEER = 153023, // 指派工程师
    
    ORDER_TRANSFER = 153030,
    OrderEnquiry = 740000,
    ORDER_CONFIRM_CUSTOMER = 153040,
    IsSelfTask=153011, // 直拍自己

    // 任务管理
    OrderTask=200000,
    // 投诉工单
    ComplaintOrder=170000,
    ORDER_COMPLAINT_LOOK = 431,
    ORDER_COMPLAINT_DEAL = 432,

    // 巡检管理
    EORDER_POLLING = 580,
    PollingOrderList=161000,
    PollingOrderEven=162000,
    PollingOrderCheck=163000,
    PollingOrderAddOnce=164000,
    PollingOrderSeting=169000,
    // 安装
    InstallModule = 230000,
    InstallAdd=231000,
    InstallSource=232000,
    InstallSetting=239000,
    InstallOrderSource=896100,
    InstallOrderNum=896200,
    InstallOrderAppointment=896300,

    OrderInstallAplay=240000,
    OrderInstallAplayAdd=241000,

    // 自动推单
    GroupPush=380000,
    GroupPushAddress=381000, // 地址推单
    GroupPushCustomer=382000,
    GroupPushFault=383000,
    GroupPushTags=384000,
    GroupPushCombine=385000,
    GroupPushCustomerDept=386000,

    // 客户
    CUSTOMER_COMPANY = 730,
    CustomerAliasGroup=651000,

    RelatedModule=670000, // 客户关联模块
    CustomerRelationRelation=670010,
    CustomerRelationRelationOrder=670050,

    SERVICER_COMPANY=700000,//维修方合作维修言模块

    Staff=250000, // 人员管理
    StaffALL=251000,
    StaffRole=252000,
    StaffDepatment=253000,
    StaffAutoAssign=390000,
    StaffScheduling=255000,

     // 库存管理
     Stock=360000,
     StockTz=361000,
     StockCheck=362000,
     StockInOutRecord=364000, //实为库存统计
     Stocksetting=365000,
     StockApplyInoutRecord=368300,
    // 考勤
    PunchTheClock=254000,
    PunchTheClockRecord=261000,
    PunchTheClockSetting=262000,
    // 分公司
    BranchCompany=400000, // 分公司模块
    BruanchOrderCusGroup=406000,
    BruanchOrderCusOrder=401000,
    BranchOrderServicer=404000,
    BruanchOrderDayCheck=403000,
    // 公司公告
    CompanyNotice=570000,
    CompanyNoticeInner=572000,
    CompanyCustomerNotice=571000,

    // 设备管理
    Device=300000,
    ProductAuth=304000,
    ProductAuthSer=305000,

    // 模版设置
    Template=610000,
    TemplateDiyField=853000,
    TemplateRepair=851000,
    TemplateOrder=631100,
    TemplateTroubleDescribleTags=611000,
    TemplateImageTags=613000,
    TemplateRemarkTags=614000,
    TemplateEvaluateTags=607000,
    TemplateEvaluateCustomer=618000,
    TemplateAddedProgressTags=612000,
    TemplateAplayReason=616000,
    TemplateQuestionBank=617000,
    TemplateWorkTime=896500,

    KPI=530000,
    KPISETTING=531000,
    // 统计报表
    STATISTICS = 550000,
    StatisticsPerson=551000,
    StatisticsDeptCusPrice=551100,
    StatisticsDeptSerPrice=551200,
    StatisticsDeptCusOrder=551500,
    StatisticsDeptSerOrder=551600,
    StatisticsDeptSerOrderWorkTime=551810,
    StatisticsCusOrder=552000,
    StatisticsDiyOrder=553000,
    StatisticsSerDeptDiyOrder=553100,
    StatisticsBigData=554000,
    StatisticsServer=555000,
    StatisticsCusDiyOrder=556000,
    StatisticsCusPrice=552100,
    StatisticsParts=559100,
    StatisticsDevice=557000,
    StatisticsFaultPhenomenon=558100,
    StatisticsFaultType=558200,
    StatisticsAddress=558300,
    //结算模块
    Settlement = 156000,
    SettlementDeal = 156300,
    // 系统设置
    System=600000,
    SystemCompany=601000,
    SystemModule=602000,
    SystemOrderSetting=604000,
    SystemOperationLog=606000,
    ServerIndex=605000,

    // 新报修单评价
    OrderEvaluate=125800,

}
export enum OrderType {
    FixModule = 2,
    InstallModule = 3,
    OtherModule = 1,
    CheckModule=4
}

export enum ModuleType {
    ORDER_IMAGE = 1010,
    ORDER_VIDEO = 1020,
    ORDER_AUDIO = 1030,
    ORDER_TAG = 1040,
    ORDER_FAULTTYPE = 1050,
    ORDER_FAULTPHENOMENON = 1051,
    ORDER_PRODUCT = 1060,
    ORDER_DEVICE = 1070,
    ORDER_WORKTIME =1079 ,
    ORDER_REMARK = 1080,
    ORDER_FIX_SUMMARY = 1081,
    ORDER_PARTS = 1090,
    ORDER_COST = 1100,
    ORDER_DEAL_IMAGE = 1110,
    ORDER_DEAL_VIDEO = 1160,
    ORDER_ADDRESS = 1120,
    ORDER_DEPARTMENT = 1130,
    ORDER_APPOINTMENT_TIME = 1140,
    ORDER_CUSTOM_ADDRESS = 1150,
    ORDER_REPORT_ADDRESS_DETAIL = 1170,
    TASK_VISIT = 1190,
    ORDER_SN = 1191,
    ORDER_DIY_ONE = 1192,
    ORDER_DIY_TWO = 1193,
    ORDER_WORD_FILE = 1194,
    ORDER_TASK_COORDINATION=1195,

}

export enum ViewType{
     // 报修
     REPORT,
     // 添加订单
     REPORT_ADD,
     // 巡检报修单
     REPORT_INSPECTION,
     // 订单处理
     DEAL_ORDER,
     // 任务处理
     DEAL_TASK,
     // 巡检订单处理
     DEAL_INSPECTION_ORDER,
     // 巡检任务处理
     DEAL_INSPECTION_TASK,
     // 订单详情
     DETAIL_ORDER,
     // 任务详情
     DETAIL_TASK,
     // 巡检订单详情
     DETAIL_INSPECTION_ORDER,
     // 巡检任务详情
     DETAIL_INSPECTION_TASK,
     // 报修
     DEAL_REPORT,
     // 添加订单
     DETAIL_REPORT,
     // 点检
     CHECK_POINT,
     // 其他
     OTHER,
     // 添加巡检
     POLLING_ADD
}
